<style lang="less">
    .disable {
        cursor: not-allowed !important;
        opacity: 0.4;
    }
</style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" :showTippy="false" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";
    declare var eLayoutType: any;

    @Component({
        components: {
            MenuList,
        },
    })
    export default class EditDrops extends Vue {
        tempDisable = !appConfig.isBuild;
        editClick(type) {
            let ts: any = this;
            let view = window["_view"];
            let tool = (view && view._tool) || null;
            let map = new Map([
                [
                    "undo",
                    () => {
                        view.undo();
                    },
                ],
                [
                    "redo",
                    () => {
                        view.redo();
                    },
                ],
                [
                    "cut",
                    () => {
                        document.execCommand("cut");
                    },
                ],
                [
                    "copy",
                    () => {
                        document.execCommand("copy");
                    },
                ],
                [
                    "styleBrush",
                    () => {
                        if (this.isActiveShape) {
                            this.isStyleBrushActive = !this.isStyleBrushActive;
                        }
                        view.styleBrush(this.isStyleBrushActive);
                    },
                ],
                // [
                //     "setDefaultStyle",
                //     () => {
                //         ts.$bus.$emit("openNavigationTool", "theme");
                //     },
                // ],
                ["spellCheck", () => {}],
                ["changeSpellCheckLanguage", () => {}],
                [
                    "replace",
                    () => {
                        ts.$bus.$emit("openNavigationTool", "search");
                    },
                ],
                [
                    "createSmartShape",
                    () => {
                        this.clickCreate();
                    },
                ],
            ]);
            map.get(type)();
            this.$track("menu", "edit", type);
            this.$emit("closeDrop");
        }
        pastes(e: MouseEvent) {
            this.$track("menu", "edit", "paste");
            window["_view"].paste(e);
        }
        pastePlains(e: MouseEvent) {
            this.$track("menu", "edit", "pastePlainText");
            window["_view"].pastePlainText(e);
        }
        clickCreate() {
            let autoCreate = true;
            let shapeData: Array<number> = [-1, -1]; // 用户选择的图形id
            let baseShapeIdList: Array<number> = []; // 选中的图形的id
            window["_view"].getSmartShapeItem().then((e) => {
                baseShapeIdList = e.map((v: any) => {
                    return v["id"];
                });

                if (baseShapeIdList.length == 0) return;

                if (this.childShape) {
                    // 有子形状
                    if (this.childShape <= 10) {
                        shapeData[0] = baseShapeIdList[0];
                        autoCreate = true;
                    } else {
                        shapeData = baseShapeIdList.slice(0, 2);
                        autoCreate = false;
                    }
                } else {
                    // 没有子形状
                    if (baseShapeIdList.length < 2) {
                        shapeData[0] = baseShapeIdList[0];
                        autoCreate = true;
                    } else {
                        shapeData = baseShapeIdList.slice(0, 2);
                        autoCreate = false;
                    }
                }

                if (autoCreate) {
                    this.autoCreate(shapeData);
                } else {
                    this.showModal("CreateSmartShape");
                }
            });
        }
        // 自动创建垂直分布类型智能形状
        autoCreate(shapeData) {
            // 使用枚举值以获得更好的语义化
            const smartShapeType = eLayoutType.VerticalList;
            // const smartShapeType = 0x1011;
            window["_view"].createSmartShape(shapeData, smartShapeType);
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        // 弹窗手动创建
        showModal(type) {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: type,
            });
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "undo",
                    () => {
                        event.stopPropagation();
                        this.canUndo && this.editClick("undo");
                    },
                ],
                [
                    "redo",
                    () => {
                        event.stopPropagation();
                        this.canRedo && this.editClick("redo");
                    },
                ],
                [
                    "cut",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.editClick("cut");
                    },
                ],
                [
                    "copy",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.editClick("copy");
                    },
                ],
                [
                    "paste",
                    () => {
                        event.stopPropagation();
                        this.pastes(event);
                    },
                ],
                [
                    "pastePlain",
                    () => {
                        event.stopPropagation();
                        this.pastePlains(event);
                    },
                ],
                [
                    "styleBrush",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.editClick("styleBrush");
                    },
                ],
                // [
                //     "setDefaultStyle",
                //     () => {
                //         event.stopPropagation();
                //         this.isActiveShape && this.editClick("setDefaultStyle");
                //     },
                // ],
                [
                    "spellCheck",
                    () => {
                        event.stopPropagation();
                        this.editClick("spellCheck");
                    },
                ],
                [
                    "changeSpellCheckLanguage",
                    () => {
                        event.stopPropagation();
                        this.editClick("changeSpellCheckLanguage");
                    },
                ],
                [
                    "find&replace",
                    () => {
                        event.stopPropagation();
                        this.editClick("replace");
                    },
                ],
                [
                    "createSmartShape",
                    () => {
                        this.isActiveShape && this.editClick("createSmartShape");
                    },
                ],
            ]);
            const onClick = clickEvents.get(key);
            onClick && onClick();
        }
        get menuList() {
            let list = [
                {
                    key: "undo",
                    shortcut: "Ctrl+Z",
                    disabled: !this.canUndo,
                    extraClass: this.activeFunc == "editUndo" && "activeFunc",
                },
                {
                    key: "redo",
                    shortcut: "Ctrl+Y",
                    disabled: !this.canRedo,
                    extraClass: this.activeFunc == "canRedo" && "activeFunc",
                },
                { divide: true },
                {
                    key: "cut",
                    shortcut: "Ctrl+X",
                    disabled: !this.isActiveShape,
                    extraClass: this.activeFunc == "editCut" && "activeFunc",
                },
                {
                    key: "copy",
                    shortcut: "Ctrl+C",
                    disabled: !this.isActiveShape,
                    extraClass: this.activeFunc == "editCopy" && "activeFunc",
                },
                {
                    key: "paste",
                    shortcut: "Ctrl+V",
                    extraClass: this.activeFunc == "editPaste" && "activeFunc",
                },
                { key: "pastePlain", isRender: this.tempDisable && !this.isTeamsApp },
                { divide: true },
                {
                    key: "styleBrush",
                    disabled: !this.isActiveShape,
                    extraClass: this.activeFunc == "editStyleBrush" && "activeFunc",
                },
                // {
                //     key: "setDefaultStyle",
                //     disabled: !this.isActiveShape,
                //     extraClass: this.activeFunc == "editSetDefaultStyle" && "activeFunc",
                // },
                { divide: true },
                { key: "spellCheck", isRender: this.tempDisable, shortcut: "F7" },
                { key: "changeSpellCheckLanguage", isRender: this.tempDisable },
                {
                    key: "find&replace",
                    shortcut: "Ctrl+F",
                    extraClass: this.activeFunc == "editReplace" && "activeFunc",
                },
                { divide: true },
                {
                    key: "createSmartShape",
                    disabled: !this.canCreateSmartShape,
                    extraClass: this.activeFunc == "editCreateSmartShape" && "activeFunc",
                },
            ];

            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(item.divide ? item : Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "edit-drops", list: resultList };
        }
        get childShape() {
            return this.$store.state.shape.childShape;
        }
        get isActiveShape() {
            return this.$store.state.shape.isActived;
        }
        // 格式刷状态
        get isStyleBrushActive() {
            return !!this.$store.state.shape.isStyleBrushActive;
        }
        set isStyleBrushActive(v) {
            this.$store.commit("setShapeStatus", { type: "isStyleBrushActive", data: v });
        }
        get canUndo() {
            return this.$store.state.ui.canUndo;
        }
        get canRedo() {
            return this.$store.state.ui.canRedo;
        }
        get canCreateSmartShape() {
            return this.$store.state.shape.canCreateSmartShape && this.isActiveShape;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "undo": "撤销",
    "redo": "重做",
    "cut": "剪切",
    "copy": "复制",
    "paste": "粘贴",
    "pastePlain": "粘贴纯文本",
    "styleBrush": "格式刷",
    "setDefaultStyle": "快速样式",
    "spellCheck": "拼写检查",
    "changeSpellCheckLanguage": "设置拼写检查语言",
    "find&replace": "查找&替换",
    "createSmartShape": "创建智能形状"
  },
  "en": {
    "undo": "Undo",
    "redo": "Redo",
    "cut": "Cut",
    "copy": "Copy",
    "paste": "Paste",
    "pastePlain": "Paste Text Only",
    "styleBrush": "style Brush",
    "setDefaultStyle": "Quick Style",
    "spellCheck": "Spelling Check",
    "changeSpellCheckLanguage": "Choose Language for spelling check",
    "find&replace": "Find & Replace",
    "createSmartShape": "Create Smart Shape"
  },
  "fr": {
    "undo": "Défaire",
    "redo": "Refaire",
    "cut": "Couper",
    "copy": "Copier",
    "paste": "Coller",
    "pastePlain": "Coller du texte brut",
    "styleBrush": "Pinceau de style",
    "setDefaultStyle": "Style rapide",
    "spellCheck": "Vérification orthographique",
    "changeSpellCheckLanguage": "Définir la langue de vérification orthographique",
    "find&replace": "Rechercher et remplacer",
    "createSmartShape": "Créer SmartShape"
  },
  "de": {
    "undo": "Rückgängig machen",
    "redo": "Wiederherstellen",
    "cut": "Ausschneiden\nAusschneiden",
    "copy": "Kopieren",
    "paste": "Einfügen\nEinsetzen   ",
    "pastePlain": "Nur Text einfügen",
    "styleBrush": "Stil Pinsel",
    "setDefaultStyle": "Quick Style",
    "spellCheck": "Rechtschreibprüfung",
    "changeSpellCheckLanguage": "Sprache für Rechtschreibprüfung auswählen",
    "find&replace": "Suchen & Ersetzen",
    "createSmartShape": "SmartShape´erstellen"
  },
  "jp": {
    "undo": "元に戻す",
    "redo": "やり直し",
    "cut": "切り取り",
    "copy": "コピー",
    "paste": "貼り付け",
    "pastePlain": "書式なしのテキストを貼り付け",
    "styleBrush": "書式のコピー/貼り付け",
    "setDefaultStyle": "クイック書式",
    "spellCheck": "スペルチェック",
    "changeSpellCheckLanguage": "スペルチェックの言語を選択",
    "find&replace": "検索と置換",
    "createSmartShape": "SmartShapeを新規作成"
  },
  "es": {
    "undo": "Deshacer",
    "redo": "Rehacer",
    "cut": "Cortar",
    "copy": "Copia",
    "paste": "Pegar",
    "pastePlain": "Pegar sólo texto",
    "styleBrush": "Cepillo de estilo",
    "setDefaultStyle": "Estilo rápido",
    "spellCheck": "Revisión de ortografía",
    "changeSpellCheckLanguage": "Elija el idioma para la revisión de la ortografía",
    "find&replace": "Encontrar y reemplazar",
    "createSmartShape": "Crear una forma inteligente"
  },
  "pt": {
    "undo": "Desfazer",
    "redo": "Refazer",
    "cut": "Cortar",
    "copy": "Copiar",
    "paste": "Colar",
    "pastePlain": "Colar Apenas Texto",
    "styleBrush": "\nEscova de estilo",
    "setDefaultStyle": "Estilo Rápido",
    "spellCheck": "Verificação Ortográfica",
    "changeSpellCheckLanguage": "Escolher Língua de verififcação ortográfica",
    "find&replace": "Encontrar & Substituir",
    "createSmartShape": "Criar Forma Inteligente"
  },
  "it": {
    "undo": "Annulla",
    "redo": "Ripeti",
    "cut": "Taglia",
    "copy": "Copia",
    "paste": "Incolla",
    "pastePlain": "Incolla Solo il Testo",
    "styleBrush": "Pennello stile",
    "setDefaultStyle": "Stile Rapido",
    "spellCheck": "Controllo Ortografico",
    "changeSpellCheckLanguage": "Seleziona la lingua per il controllo ortografico.",
    "find&replace": "Trova e Sostituisci",
    "createSmartShape": "Crea una Smart Shape"
  },
  "tw": {
    "undo": "復原",
    "redo": "取消復原",
    "cut": "剪下",
    "copy": "複製",
    "paste": "貼上",
    "pastePlain": "貼上純文本",
    "styleBrush": "格式刷",
    "setDefaultStyle": "快速樣式",
    "spellCheck": "拼寫檢查",
    "changeSpellCheckLanguage": "設置拼寫檢查語言",
    "find&replace": "查找&替換",
    "createSmartShape": "建立SmartShape"
  }
}
</i18n>
